//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        search: {
            type: Object,
            default: () => ({
                id: ''
            })
        }
    },
    data () {
        return {
            form: {
                id:"",
                auditStatus:"",
                auditOpinion:"",
            },
        }
    },
    computed:{
    },
    watch:{
    },
    methods: {
        submitHandler() {
            this.$emit('audit');
        },
        cancleHandler() {
            this.$emit('close');
        },
    },
    mounted: function() {
        this.form.id = this.search.id;
    }
}
